"use client"
import { LinkButton } from "@cloudflare/kumo/components/button"
import { HouseIcon } from "@phosphor-icons/react"
import { StandaloneCard } from "@/components/kumo/standalone-card"
export default function NotFound() {
  return (
    <StandaloneCard label="Page not found" title="Page not found">
      <p className="text-kumo-subtle">
        Nothing lives at this address. The link may be old or mistyped.
      </p>
      <LinkButton
        href="/"
        size="lg"
        icon={HouseIcon}
        className="w-full max-w-none justify-center"
      >
        Go to home
      </LinkButton>
    </StandaloneCard>
  )
}
